import type { BlokAccordion, BlokAccordions, BlokLink } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import BlokWrap from "../BlokWrap";

import {
	AccordionContent,
	AccordionIndicator,
	AccordionItem,
	AccordionRoot,
	AccordionTrigger,
} from "@/components/ui/Accordion/Accordion";
import { Button } from "@/components/ui/Button";
import { RichTextRender } from "@/components/ui/RichTextRender";
import { clsx } from "@frend-digital/ui";
import styles from "./AccordionBlok.module.css";
import { SegmentControl } from "@/components/SegmentControl";

export const AccordionBlok = ({
	blok,
	preview,
	className,
}: BlokProps<BlokAccordions> & { className?: string }) => {
	return (
		<SegmentControl segments={blok}>
			<BlokWrap editable={blok} asChild>
				<div className={styles.root}>
					<div className={clsx(styles.grid, className)}>
						{blok.title && <h2 className={styles.title}>{blok.title}</h2>}
						{blok.tags && blok.tags?.length > 0 && (
							<div className={styles.tags}>
								{blok.tags?.map((tag: BlokLink) => (
									<Button key={tag._uid} className={styles.tag}>
										{tag.text}
									</Button>
								))}
							</div>
						)}
						{blok.accordions?.map((accordion: BlokAccordion) => (
							<SegmentControl segments={accordion} key={accordion._uid}>
								<AccordionRoot key={accordion.title} title={accordion?.title || ""}>
									{accordion?.text && (
										<AccordionItem key={blok._uid}>
											<AccordionTrigger>
												<h3 className={styles.accordionTitle}>{accordion.title}</h3>
												<AccordionIndicator />
											</AccordionTrigger>
											<AccordionContent>
												<RichTextRender
													blok={accordion.text}
													preview={preview}
													className={styles.accordionContent}
												/>
											</AccordionContent>
										</AccordionItem>
									)}
								</AccordionRoot>
							</SegmentControl>
						))}
					</div>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
